import script from "./PasswordResetRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetRequest.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetRequest.vue?vue&type=style&index=0&id=b6897f10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6897f10"]])

export default __exports__